<template>
    <div id="cust_component" class="component_body">
        <headerComponent title = "New  Password" />   
         <div class="container-fluid">
            <div class="row">
                <div class="col-11 pwd_update_div m-auto">
                    <div class='row'>
                        <div class='col-11 m-auto text-center'> 
                           <div class='text-center'>
                                <img  src="../../assets/customer/images/success_icon.svg">
                                <h4 class='mt-5 '><b>Password Updated</b></h4>
                                <h6 class=' m-0 ash text-break font-18'>Please wait while we redirect you to the page where you were before.</h6>  

                                <router-link to="/custlogin">
                                <input type="button" class="btn btn-pink  btn-rounded btn-block btn-lg mt-4" value="Log In Now">
                                </router-link>
                           </div>

                        </div>
                    </div>

                </div>
            </div>
         </div>
    
    </div>       
</template>
<style scoped>

.pwd_update_div{
    max-width: 350px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
<script>

import headerComponent from '@/components/cust_components/cust_header_component.vue';
  
    export default {
      name: 'pwdupdate',
        data() {
          return {
            mobile_view : false,
          }
        },
        components: {     
            headerComponent,
        },
        mounted(){
            this.responsive_view();
            window.addEventListener('resize', this.responsive_view);
        },
        created(){
           setTimeout( () => this.$router.push({ path: '/custlogin'}), 5000);
        },
        methods:{
            async responsive_view(){

                await this.$store.commit('responsive_view', window.innerWidth)
            
            },
        }
    }
</script>


